import React, { useState, useEffect } from "react";
import { Container, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

const MessageDialog = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openCompleteModal, setOpenCompleteModal] = useState(false);

  // location.state があれば完了モーダルを表示
  useEffect(() => {
    if (location.state && location.state.showCompleteModal) {
      setOpenCompleteModal(true);
    }
  }, [location.state]);

  const handleCloseModal = () => {
    setOpenCompleteModal(false);
    // モーダルを閉じた後、state をリセットするために replace で更新する
    navigate(location.pathname, { replace: true, state: {} });
  };

  return (
    
      <Dialog open={openCompleteModal} onClose={handleCloseModal}>
        <DialogTitle>Upload Success</DialogTitle>
        <DialogContent>
          <Typography>
            Paper uploading is complete!
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
  
  );
};

export default MessageDialog;
